import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { EditIcon } from "../../../assets/img/EditIcon";
import { copyIcon } from "../../../assets/img/icons/copyIcon";
import { TelegramIcon } from "../../../assets/img/TelegramIcon";
import { TwitterIcon } from "../../../assets/img/TwitterIcon";
import { toggleEditProfileModal } from "../../../store/app/appSlice";
import { formatAddress } from "../../../utils/utils";
import { ProfileFilter } from "../ProfileFilter/ProfileFilter";
import { ProfileMobileFilter } from "../ProfileMobileFilter/ProfileMobileFilter";
import { ProfileAuthor, ProfileImage, ProfileLinks, ProfileMain, ProfileSidebarWrapper, ProfileText, UserButton } from "./ProfileSidebar.styled";

export const ProfileSidebar = ({ user }) => {
  const [copyAddress, setCopyAddress] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (copyAddress === true) {
      setTimeout(() => {
        setCopyAddress(false);
      }, 3000);
    }
  }, [copyAddress]);

  return (
    <ProfileSidebarWrapper>
      <ProfileMain>
        <ProfileImage>
          <img src='../../../assets/img/default/ava/1.png' alt='ava' />
        </ProfileImage>
        <h4>Robotos NFT</h4>
        <span>
          <button
            onClick={() => {
              navigator.clipboard.writeText("0x27A95F8e0f465c8835B0E887f8A1531440067721");
              setCopyAddress(true);
            }}>
            {copyIcon()}
          </button>
          {copyAddress && "Copied!"}
          {formatAddress("0x27A95F8e0f465c8835B0E887f8A1531440067721")}
        </span>
        <h4>Let people know more about you</h4>
        <ProfileText>Fill out personal information: nickname, description, and social networks. Add a new banner.</ProfileText>
        <ProfileLinks>
          <a href='/'>{TelegramIcon()}</a>
          <a href='/'>{TwitterIcon()}</a>
        </ProfileLinks>
        {user ? (
          <UserButton onClick={() => dispatch(toggleEditProfileModal())}>{EditIcon()}Edit Profile</UserButton>
        ) : (
          <ProfileAuthor>
            Created by <a>Cinematic</a>
          </ProfileAuthor>
        )}
      </ProfileMain>
      <ProfileFilter />
      <ProfileMobileFilter />
    </ProfileSidebarWrapper>
  );
};
